// Generated by ReScript, PLEASE EDIT WITH CARE


var pageviewKafkaEndpoint = "/log_pageview_to_kafka";

var utm_source = "utm_source";

var utm_medium = "utm_medium";

var utm_campaign = "utm_campaign";

var utm_term = "utm_term";

var utm_content = "utm_content";

var country = "INDIA";

var timeFormat = "YYYY-MM-DD hh:mm:ss";

export {
  pageviewKafkaEndpoint ,
  utm_source ,
  utm_medium ,
  utm_campaign ,
  utm_term ,
  utm_content ,
  country ,
  timeFormat ,
}
/* No side effect */
